import React, {Component} from 'react';
import { cartApi, wishlistApi, setGuestCartId } from '../../api/Api';
import {loadStartupHome, loadStartupMenu} from '../../api/storefrontStartup';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

import {isLogin, logout} from '../../utils';
import Menu from './Menu';
import OfferBand from './OfferBand';
import './HeaderTheme.css';
import AccountConfirmationDialog from '../account/AccountConfirmationDialog';
import {getCompareCount} from '../../utils/byoscart';
import store, {CART_COUNT_UPDATE, COMPARE_COUNT_UPDATE} from '../../utils/store';

export class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: [],
            serviceCheck: false,
            isScrolled: false,
            headerHeight: 0,
            wishlistCount: 0,
            confirmLogout: false,
            loggingOut: false,
        };

        this.handleLogout = this.handleLogout.bind(this);
        this.handleWindowScroll = this.handleWindowScroll.bind(this);
        this.updateHeaderHeight = this.updateHeaderHeight.bind(this);
        this.loadWishlistCount = this.loadWishlistCount.bind(this);
        this.headerRef = React.createRef();
    }

    async loadCartCount() {
        try {
            const cartResponse = await cartApi.detail({
                country_id: localStorage.getItem('country_id') || undefined,
            });
            const cartData = cartResponse.data || {};
            if (cartData.status !== 'success') return;
            setGuestCartId(cartData.guest_cart_id);
            store.dispatch({type: CART_COUNT_UPDATE, value: cartData.cartCount || 0});
        } catch (error) {
            console.error(error);
        }
    }

    async loadWishlistCount() {
        if (!isLogin()) {
            this.setState({wishlistCount: 0});
            return;
        }
        try {
            const response = await wishlistApi.list({optional: true});
            const items = response.data?.data;
            this.setState({wishlistCount: isLogin() && Array.isArray(items) ? items.length : 0});
        } catch (error) {
            // Leave the last known count visible if the request fails.
        }
    }

    async componentDidMount() {
        this.isMountedHeader = true;
        this.updateHeaderHeight();
        if (typeof ResizeObserver !== 'undefined' && this.headerRef.current) {
            this.headerResizeObserver = new ResizeObserver(this.updateHeaderHeight);
            this.headerResizeObserver.observe(this.headerRef.current);
        }
        this.handleWindowScroll();
        window.addEventListener('scroll', this.handleWindowScroll, {passive: true});
        window.addEventListener('resize', this.updateHeaderHeight);
        window.addEventListener('wishlist-updated', this.loadWishlistCount);
        try {
            const resVal = await loadStartupMenu();
            if (this.isMountedHeader && resVal.status === 'success') {
                this.setState({menu: resVal.data});
            }
        } catch (error) {
            console.error(error);
        } finally {
            if (this.isMountedHeader) this.setState({serviceCheck: true});
        }

        if (!this.isMountedHeader) return;
        const path = this.props.location?.pathname || window.location.pathname;
        if (path === '/') {
            try {
                await loadStartupHome();
            } catch (error) {
                // Badge loading must still proceed if the home request fails.
            }
        }
        if (!this.isMountedHeader) return;
        this.loadCartCount();
        this.loadWishlistCount();

        this.compareTimer = setTimeout(() => {
            store.dispatch({type: COMPARE_COUNT_UPDATE, value: getCompareCount()});
        }, 200);

        this.updateHeaderHeight();
    }

    componentWillUnmount() {
        this.isMountedHeader = false;
        clearTimeout(this.compareTimer);
        if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
        window.removeEventListener('scroll', this.handleWindowScroll);
        window.removeEventListener('resize', this.updateHeaderHeight);
        window.removeEventListener('wishlist-updated', this.loadWishlistCount);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location?.pathname !== this.props.location?.pathname) {
            this.loadWishlistCount();
        }
        if (prevState.isScrolled !== this.state.isScrolled) {
            this.updateHeaderHeight();
        }
    }

    handleWindowScroll() {
        const isScrolled = window.scrollY > 10;
        if (this.state.isScrolled !== isScrolled) {
            this.setState({isScrolled});
        }
    }

    updateHeaderHeight() {
        const headerHeight = this.headerRef.current ? this.headerRef.current.offsetHeight : 0;
        if (this.state.headerHeight !== headerHeight) {
            this.setState({headerHeight});
        }
    }

    async handleLogout() {
        if (!this.state.confirmLogout || this.state.loggingOut) return;
        this.setState({loggingOut:true});
        try {
            await logout();
        } finally {
            this.setState({loggingOut:false, confirmLogout:false});
        }
    }



    render() {
        const profileName = (localStorage.getItem('natureway_username') || '').trim();
        const desktopHeaderClassName = `ps-header ps-header--1 ps-header--natureway ${this.state.isScrolled ? 'ps-header--scrolled' : ''}`;

        return (
            <div>
                <header className={desktopHeaderClassName} ref={this.headerRef}>
                    <OfferBand />
                    <div className="ps-header__main">
                        <div
                            className="ps-header__kolam-border"
                            aria-hidden="true"
                            style={{backgroundImage: "url('/assets/img/kolam-header-border.svg')"}}
                        />
                        <div className="container">
                            <div className="ps-header__mainRow">
                                <div className="ps-header__brand">
                                    <Link to="/" className="ps-header__brandLink" aria-label="Home">
                                        <img src="/assets/img/logo.png" alt="Nature Way" className="ps-header__brandLogo" />
                                    </Link>
                                </div>

                                <div className="ps-header__navSlot">
                                    <Menu menu={this.state.menu} loading={!this.state.serviceCheck} isScrolled={this.state.isScrolled} />
                                </div>

                                <div className="ps-header__actions">
                                    {isLogin() ? (
                                        <div className="ps-header__account dropdown">
                                            <button
                                                type="button"
                                                className="ps-header__accountToggle dropdown-toggle"
                                                id="dropdownMenuButton"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                                aria-label="Your account"
                                                title={profileName || 'Your account'}
                                            >
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" aria-hidden="true" focusable="false"><circle cx="12" cy="8" r="4" /><path d="M4 21v-2a8 8 0 0 1 16 0v2" /></svg>
                                                <span>{profileName !== '' ? profileName : 'Profile'}</span>
                                            </button>
                                            <div className="dropdown-menu accountDropdownMenu" aria-labelledby="dropdownMenuButton">
                                                <Link to="/account" className="ps-header__item_child">My Profile</Link>
                                                <Link to="/orders" className="ps-header__item_child">Orders</Link>
                                                <Link to="/wishlist" className="ps-header__item_child">Wishlist</Link>
                                                <button type="button" onClick={() => this.setState({confirmLogout:true})} className="ps-header__item_child ps-header__logout">Logout</button>
                                            </div>
                                        </div>
                                    ) : (
                                        <Link className="ps-header__actionLink ps-header__actionLink--signin" to="/signin" aria-label="Sign in or sign up">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" aria-hidden="true" focusable="false"><circle cx="12" cy="8" r="4" /><path d="M4 21v-2a8 8 0 0 1 16 0v2" /></svg>
                                            <span>Sign In / Sign Up</span>
                                        </Link>
                                    )}

                                    <Link className="ps-header__actionLink ps-header__actionLink--wishlist" to="/wishlist" aria-label={`Wishlist, ${this.state.wishlistCount} saved items`}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d="M20.5 5.5a5 5 0 0 0-7 0L12 7l-1.5-1.5a5 5 0 0 0-7 7L12 21l8.5-8.5a5 5 0 0 0 0-7Z"/></svg>
                                        <span className="badge" aria-hidden="true">{this.state.wishlistCount}</span>
                                    </Link>

                                    <Link className="ps-header__actionLink ps-header__actionLink--cart" to="/cart" id="cart-mini" aria-label={`Shopping cart, ${this.props.count || 0} items`}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
                                            <path d="M5 7h14l1.5 15H3.5L5 7Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
                                            <path d="M8 10V6a4 4 0 0 1 8 0v4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                                        </svg>
                                        <span className="badge" aria-hidden="true">{this.props.count || 0}</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </header>
                <div className="ps-header__fixed-spacer" aria-hidden="true" style={{height: this.state.headerHeight}} />

                {this.state.confirmLogout && <AccountConfirmationDialog
                    title="Sign out of your account?"
                    description="You’ll need to sign in again to access your account, orders and saved favourites."
                    cancelLabel="Stay signed in" confirmLabel="Sign out" busyLabel="Signing out…"
                    busy={this.state.loggingOut}
                    onCancel={() => this.setState({confirmLogout:false})}
                    onConfirm={this.handleLogout}
                />}
            </div>
        );
    }
}

const mapStatetoProps = (state) => {
    return {
        count: state.cart.count,
        comparecount: state.compare.count,
    };
};

export default connect(mapStatetoProps, null)(Header);
